var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { key: "card-" + _vm.current, staticClass: "message gallery-image-card" },
    [
      _c("div", { staticClass: "card", class: { selected: _vm.isSelected } }, [
        _vm.card.imageUrls && _vm.card.imageUrls.length > 0
          ? _c("div", { staticClass: "card-image" }, [
              _c(
                "div",
                { staticClass: "image-wrapper" },
                [
                  _c(
                    "ssr-carousel",
                    {
                      key: Math.random() * 100000,
                      staticClass: "image-slider",
                      attrs: {
                        loop: false,
                        "show-arrows": _vm.current,
                        "show-dots": _vm.current,
                        "slides-per-page":
                          _vm.card.imageUrls.length > 4 ? 2 : 1,
                        gutter: 0,
                      },
                    },
                    _vm._l(_vm.card.imageUrls, function (image) {
                      return _c("div", { key: image, staticClass: "slide" }, [
                        _c("img", { attrs: { src: image } }),
                      ])
                    }),
                    0
                  ),
                ],
                1
              ),
            ])
          : _vm.card.imageUrl
          ? _c("div", { staticClass: "card-image" }, [
              _c("div", { staticClass: "image-wrapper" }, [
                _c("img", { attrs: { src: _vm.card.imageUrl } }),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "card-content" }, [
          _c("div", { staticClass: "card-title" }, [
            _vm._v(
              "\n                " + _vm._s(_vm.card.title) + "\n            "
            ),
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "card-description",
            domProps: { innerHTML: _vm._s(_vm.card.description) },
          }),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "buttons" },
          _vm._l(_vm.card.buttons, function (button, i) {
            return _c(
              "div",
              {
                key: button.id,
                staticClass: "single-button",
                class: {
                  selected:
                    _vm.isSelected && _vm.selectedButtonId === button.id,
                },
                on: {
                  click: function ($event) {
                    return _vm.sendButtonMessage("GALLERY", {
                      cardId: _vm.card.id,
                      buttonId: button.id,
                      blockId: _vm.blockId,
                      payloadId: _vm.payloadId,
                      buttonPayload: button.payload,
                      button: button,
                    })
                  },
                },
              },
              [
                _c("div", {
                  staticClass: "single-button-text",
                  domProps: { innerHTML: _vm._s(button.title) },
                }),
              ]
            )
          }),
          0
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }